import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found.component';

export const notFoundRoute: Routes = [
	{
		path: 'not-found',
		component: NotFoundComponent,
		data: {
			pageTitle: 'error.title',
			errorMessage: 'error.http.404',
		},
	},
];
